<template>
  <teleport to="body">
    <div v-if="show" class="blocking-loader-overlay" :class="overlayClass" role="status" aria-live="polite" aria-busy="true">
      <div class="blocking-loader-overlay-center">
        <div class="blocking-loader-spinner-shell" aria-hidden="true">
          <span class="blocking-loader-ring blocking-loader-ring-outer"></span>
          <span class="blocking-loader-ring blocking-loader-ring-inner"></span>
        </div>
        <div v-if="message" class="blocking-loader-title">{{ message }}</div>
        <div v-if="detail" class="blocking-loader-detail">{{ detail }}</div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'BlockingLoaderOverlay',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: 'Loading...',
    },
    detail: {
      type: String,
      default: '',
    },
    overlayClass: {
      type: String,
      default: '',
    },
  },
};
</script>
